"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var Upload = function Upload(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.5 63.45V88a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V63.45l-5.61 5.61a2 2 0 0 1-2.83 0l-2.12-2.12a2 2 0 0 1 0-2.83l12.646-12.646a2 2 0 0 1 2.828 0l12.647 12.647a2 2 0 0 1 0 2.828l-2.122 2.122a2 2 0 0 1-2.828 0L49.5 63.45zM40.078 8.563C53.643 10.1 65.006 19.251 69.394 31.916h2.405c10.654.007 19.956 7.18 22.59 17.438 2.635 10.266-2.083 20.994-11.45 26.057l-3.329-6.158c6.546-3.538 9.833-11.012 7.999-18.158-1.837-7.155-8.345-12.174-15.812-12.179H66.8a3.5 3.5 0 0 1-3.387-2.616c-2.92-11.2-12.509-19.467-24.122-20.781-11.617-1.315-22.845 4.599-28.24 14.864C5.66 40.637 7.2 53.12 14.925 61.786L9.7 66.444C.035 55.6-1.894 39.964 4.854 27.127 11.595 14.3 25.6 6.924 40.078 8.563z",
    fill: "currentColor"
  })));
};
var _default = exports.default = Upload;